import React from "react";
import "./terms.css";

const Cancellation = () => {
  return (
    <div className="terms-page terms-page--compact">
      <div className="top-header">
        <div className="header-left">
          <img
            src="/assets/img/InstaTenders - Logo reduced.png"
            alt="Office logo"
            className="login-brand-logo"
          />
        </div>
      </div>

      <div className="terms-container">
        <div className="terms-banner">
          <h1>Cancellation Policy</h1>
          <p>
            <strong>Effective Date:</strong> 1st January 2026
          </p>
          <p>
            <strong>Platform Name:</strong> InstaTenders
          </p>
          <p>
            <strong>Company Name:</strong> InstaTenders Solutions Private
            Limited
          </p>
        </div>
        <div className="terms-card">
          <div className="terms-section">
            <h3>1. How to cancel</h3>
            <p>
              Users can cancel their subscription at any time through the
              mobile application or by contacting our support team.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. Upon cancellation</h3>
            <ul>
              <li>
                The subscription will remain active until the end of the current
                billing cycle (3, 6, or 12 months)
              </li>
              <li>
                No further renewals (if applicable) will be processed
              </li>
              <li>
                No partial or prorated refunds will be provided for the
                remaining subscription period
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>3. After your subscription ends</h3>
            <p>
              Once the subscription period ends, access to the services will be
              discontinued unless renewed.
            </p>
          </div>
        </div>
      </div>
      <div className="custom-footer">
        <div className="footer-top">
          <div className="footer-col left">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/refund">Refund Policy</a>
            <a href="/cancellation">Cancellation Policy</a>
          </div>

          <div className="footer-col right">
            <p>
              <span>📍</span> 4/159, Thiru.vi.ka Industrial Estate, Labour
              Colony 1st Street, Guindy, Chennai - 600032, Tamil Nadu, India
            </p>
            <p className="phone">
              <span>📞</span> +91 9884713801
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          Copyright © 2026. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Cancellation;
